import styled from 'styled-components'

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Similarity = styled.span`
  color: ${({ theme }) => theme.colors.cheggOrange};
  font-weight: ${({ theme }) => theme.font.weight.extraBold};
  font-size: ${({ theme }) => theme.font.text.size['3xl']};
`

export const DescriptionContainer = styled.div``
export const Description = styled.span`
  display: inline-block;
  padding-left: ${({ theme }) => theme.spacing.sm};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  font-size: ${({ theme }) => theme.font.text.size.md};
  &:first-child {
    padding-top: ${({ theme }) => theme.spacing.xs};
  }
`

export const AbsoluteContainer = styled.div`
  position: absolute;
  z-index: 100;
`
export const Container = styled.div`
  display: flex;
  top: 0;
  padding: ${({ theme }) => theme.spacing.md3};
  padding-top: ${({ theme }) => theme.spacing.sm};
  background: white;
  padding-bottom: 0;
`

export const Blur = styled.div`
  width: 100%;
  height: 20px;
  top: 50px;
  background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
`



// WEBPACK FOOTER //
// ./src/layouts/shared/SimilarityScore/styles.tsx